import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dynamic-list" }
const _hoisted_2 = { class: "item-wrapper" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.allowInline && _ctx.limit && _ctx.limit === 1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          modelValue: _ctx.formItem,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formItem) = $event)),
            _ctx.formUpdated
          ],
          errors: _ctx.errors,
          "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errors) = $event)),
          valid: _ctx.isValid,
          "onUpdate:valid": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isValid) = $event)),
          schema: _ctx.schema
        }, {
          default: _withCtx(({ handleInputChange }) => [
            _renderSlot(_ctx.$slots, "modalBody", {
              update: handleInputChange,
              errors: _ctx.errors,
              formItem: _ctx.formItem
            }, undefined, true)
          ]),
          _: 3
        }, 8, ["modelValue", "errors", "valid", "onUpdate:modelValue", "schema"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedItems, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "item", {
                  item: item,
                  index: index
                }, undefined, true),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "icon", { item: item }, undefined, true),
                  (!_ctx.readonly && _ctx.canEditItem(item))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "edit-icon",
                        onClick: () => _ctx.handleEditClick(item)
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "pen" })
                      ], 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128)),
          (!_ctx.items.length)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_5, [
                _createVNode(_component_TranslatedText, { path: "common.no-data" })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, [
            (!_ctx.readonly && !_ctx.reachedLimit)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  text: _ctx.buttonText,
                  variant: "link",
                  onClick: _ctx.handleAddClick
                }, null, 8, ["text", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_Modal, {
                key: 1,
                modelValue: _ctx.showModal,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
                title: _ctx.modalTitle,
                onCancel: _ctx.handleModalCancel,
                onConfirm: _ctx.handleModalConfirm,
                onDismiss: _ctx.handleModalDismiss
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Form, {
                    modelValue: _ctx.formItem,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formItem) = $event)),
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.errors) = $event)),
                    valid: _ctx.isValid,
                    "onUpdate:valid": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isValid) = $event)),
                    schema: _ctx.schema
                  }, {
                    default: _withCtx(({ handleInputChange }) => [
                      _renderSlot(_ctx.$slots, "modalBody", {
                        update: handleInputChange,
                        errors: _ctx.errors,
                        formItem: _ctx.formItem
                      }, undefined, true)
                    ]),
                    _: 3
                  }, 8, ["modelValue", "errors", "valid", "schema"])
                ]),
                footer: _withCtx(({ dismiss, confirm, cancel }) => [
                  (_ctx.showDeleteButton && _ctx.canEditItem(_ctx.formItem))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        text: "common.delete",
                        onClick: dismiss,
                        disabled: _ctx.disableDeleteButton,
                        variant: "error"
                      }, null, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "spacer" }, null, -1)),
                  _createVNode(_component_Button, {
                    text: "common.cancel",
                    onClick: cancel,
                    class: "spaced",
                    outline: ""
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    text: _ctx.saveButtonText,
                    onClick: confirm,
                    disabled: _ctx.disableSaveButton
                  }, null, 8, ["text", "onClick", "disabled"])
                ]),
                _: 3
              }, 8, ["modelValue", "title", "onCancel", "onConfirm", "onDismiss"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}